'use strict';

var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var id = require('./id.js');

var createIsOnline = function createIsOnline(options) {
  var id$1 = id.createId(options);

  function isOnline() {
    return _isOnline.apply(this, arguments);
  }

  function _isOnline() {
    _isOnline = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var options,
          res,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.next = 3;
              return id$1(options);

            case 3:
              res = _context.sent;
              return _context.abrupt("return", Boolean(res && res.addresses && res.addresses.length));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _isOnline.apply(this, arguments);
  }

  return isOnline;
};

exports.createIsOnline = createIsOnline;